export default (regexp: RegExp) =>
    (expression: string) =>
      regexp.test(expression)



// WEBPACK FOOTER //
// ./src/utils/gen-matcher.ts